
module Meevo.Components.Common {
    export interface IImageGalleryService {
        addExtensions(count: number, items: any): Function;
        savePositions(itemCollection: any, callback?: Function);
    }

    export interface IImageGalleryExtensions {
        images: Array<any>;
        preSave: any;
        showSavePositions: any;
        savePositions: any;
        listeners: any;
        upload: any;
    }

    export class ImageGalleryService implements IImageGalleryService {
        private _originals: any

        constructor(private dataService: Meevo.Components.BaseClasses.IDataService, private identityService: Meevo.Components.Common.IIdentityService, public reverseOrder: boolean = false) {

        }
        //  Default ng-sortable Event Callbacks :   https://github.com/a5hik/ng-sortable  :   TODO Dynamically Inject Callbacks
        listeners = {
            itemMoved: (event: any) => {
                console.log('itemMoved: ', event);
            },                                                                                          //Implementation ItemMoved
            orderChanged: (event: any) => {
                console.log('orderChanged: ', event.dest.sortableScope.modelValue);
                //this.savePositions(event.dest.sortableScope.modelValue);
            },                                                                                          //Implementation OrderChange
            dragStart: (event: any) => {
                console.log('dragStart event: ', event);
            },
            dragEnd: (event: any) => {
                console.log('dragEnd event: ', event);
            },
            containment: '#sortable-horizontal-container',                                              //optional param.
            clone: false,                                                                               //optional param for clone feature.
            allowDuplicates: false,                                                                     //optional param allows duplicate items to be dropped from the clones.
            accept: (sourceItemHandleScope: any, destSortableScope: any) => {                           //return booleam - override to determine drag is allowed or not. default is true.
                return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;     //move only within a row.
            }
        }

        preSave = (item: any, upload?: Function, save?: Function) => {

             
            upload().then(function () {                                                                   //US55959: upload function , promise, to ensure upload process is complete before the sublist.save is triggered
                var that = this;
                let preSaveItem: any = _.findWhere(that._originals, { id: item.id });
                item.imageGalleryCategoryDetail = item.imageGalleryCategoryDetail || { id: null, displayName: null };
                item.imageGalleryCategoryId = item.imageGalleryCategoryDetail.id;
                save(); 
                if (item.entityVersion === 0 || (Model.Guard.isSomething(preSaveItem) && (item.imageGalleryCategoryDetail.id === preSaveItem.imageGalleryCategoryDetail.id)))
                {
                    return;
                }
                let groups = _.groupBy(that._originals, (o: any) => { return o.imageGalleryCategoryDetail.displayName });
                let newGroup = item.imageGalleryCategoryDetail.displayName || 'Undefined'
                let group = groups[newGroup] || []
                item.position = group.length + 1;

            }, function (reason) {
                item.fileGuid = null;
            });


        
        }

        getListeners = () => {
            return this.listeners;
        }

        reOrderGroup = (itemCollection) => {
            var imageCollection = angular.copy(itemCollection);
            if (this.reverseOrder) {
                imageCollection = imageCollection.reverse();
            }
            return _.each(imageCollection, (item: any, i: number) => {
                item.position = ++i;
            });
        }

        showSavePositions = (itemCollection: any) => {
            var imageCollection = angular.copy(itemCollection);
            if (this.reverseOrder) {
                imageCollection = imageCollection.reverse();
            }
            let positionHasChanged = _.find(imageCollection, (item: any, i: number) => {
                return item.position !== ++i;
            });
            return imageCollection.length > 0 && positionHasChanged != null;
        }

        savePositions = (itemCollection: any, callback?: Function): ng.IPromise<any>  => {
            let collection = {
                TenantId: this.identityService.current().tenantId,
                ImageGalleryPositions: this.reOrderGroup(itemCollection)
            }

            return this.dataService.customMethodData('/api/Tenant/ImageGallery/Position', 'Post', collection).then(response => {
                if (_.isFunction(callback))
                    callback();
            });
        }

        addExtensions = (count: number, items: any): any => {
            let images = [];
            var that = this;
            that._originals = items;
            items = _.groupBy(items, (i: any) => { return i.imageGalleryCategoryDetail.displayName })

            for (let prop in items) {
                var orderedChildren = _.sortBy(items[prop], 'position');
                if (this.reverseOrder) {
                    orderedChildren = orderedChildren.reverse();
                }
                images.push({
                    parent: prop === 'undefined' ? 'LABEL_UNCATEGORIZED' : prop,
                    children: orderedChildren,
                    catObjectState: items[prop][0]['imageGalleryCategoryObjectState'],

                })
            }
            let upload: any;
            var extensions: IImageGalleryExtensions = {
                images: images,
                preSave: this.preSave,
                showSavePositions: this.showSavePositions,
                savePositions: this.savePositions,
                listeners: this.listeners,
                upload: upload
            }

            return extensions
        }

        static factory(): Function {
            let svc = (dataService: Meevo.Components.BaseClasses.IDataService, identityService: Meevo.Components.Common.IIdentityService, reverseOrder: boolean) => {
                return new ImageGalleryService(dataService, identityService, reverseOrder);
            }
            svc.$inject = ["meevo.components.common.DataService", "meevo.components.common.IdentityService"];
            return svc;
        }
    }



    angular.module("meevo.components.common")
        .factory("meevo.components.common.ImageGalleryService", ImageGalleryService.factory());
}

